import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";

import { COMMIT_SET_STATUS } from "@/store/enums/mutations-types";

// Chat (profile/channels/messages/contacts): lazy via ensureChatStoreModules — no entry Home.

config.rawError = true;

const store = createStore({
  state() {
    return {
      status: null,
    };
  },
  getters: {
    lastname: (state, getters, rootState: any): any => {
      return rootState.profile?.lastname;
    },
  },
  mutations: {
    [COMMIT_SET_STATUS](state, payload) {
      state.status = payload;
    },
  },
  actions: {},

  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
  },
});

export default store;
